<div class="video-wrapper ratio ratio-16x9 mb-3" (click)="loadIframe()" style="cursor: pointer;">
    <ng-container *ngIf="!iframeLoaded">
      <img [src]="thumbnailUrl" [alt]="title" class="w-100 h-100" style="object-fit: cover; border-radius: 12px;" />
      <div class="play-button"></div>
    </ng-container>
  
    <iframe
      *ngIf="iframeLoaded"
      [src]="iframeUrl"
      allowfullscreen
      frameborder="0">
    </iframe>
  </div>
  <span class="badge text-bg-warning mb-2" *ngIf="badge">{{ badge }}</span>
  <h4 class="video-title mb-1">
    <a href="#" class="text-dark text-decoration-none">{{ title }}</a>
  </h4>
  <div class="video-date text-muted small">{{ date | date }}</div>
  